const ALL_URL = {
    login: "/account/login",
    logout: '/account/logout',
    sendVerifyCodeForRegister: "/account/regist1",
    sendForgotPasswordVerifyCode: "/account/forgetpw1",
    register: "/account/regist2",
    forgotPassword: "/account/forgetpw2",
    updatePassword: "/account/changepw",
    invitelist: "/account/invitelist",
    getUserInfo: "/account/user",
    updateUserInfo: "/account/updateuser",
    getProductList: "/product/list",
    createOrder: "/shop/order",
    getPayLink: "/shop/pay",
    getOrderStatus: "/shop/orderstate",
    orderlist: "/shop/orderlist",
    orderdetail: "/shop/orderdetail",
    cancelorder: "/shop/cancelorder",
    getLatestVersion: "/base/latestversion",
    getCouponList: "/market/couponlist",
    takeCoupon: "/market/takecoupon",
    getUserAuthList: "/auth/userauth",
    dropUserAuth: "/auth/dropauth",
    consumeSummary: "/point/consume-summary",
    applyInvoice:"/invoice/apply",
    getTransactions: "/point/transactions",
    getConsumeCurrentMonth: "/point/consume-current-month",
    exportTransactions: "/point/export-transactions",
    nextRefreshPeriod :'/point/next-refresh-period',
    presignedUploadUrl:'/tasks/upload/presigned-upload-url',
    createTask: '/tasks',                                         // POST 创建任务
    getTask: '/tasks/list',                                       // POST 任务列表
    taskDetail: '/tasks/detail',                                  // POST 查询任务状态
    presignedDownloadUrl: '/tasks/:task_id/presigned-download-url', // POST 获取预签名下载地址
    deleteTask: '/tasks/delete',                                  // POST 删除任务
    renameTask: '/tasks/:task_id/rename',                         // POST 修改任务名称
};

/**
 * Mock 配置：键为 ALL_URL 中的 key，值为 true 表示该接口使用 mock 数据。
 * 仅在 dev 环境下生效，生产构建会被 tree-shake 移除。
 */
export const MOCK_CONFIG = {
    // register: true,
    // getTransactions: true,
    // consumeSummary:true,
    // orderlist: true,
    // invitelist: true,
    // presignedUploadUrl: true,
    // createTask: true,
    // getTask: true,
    // taskDetail: true,
    // presignedDownloadUrl: true,
    // deleteTask: true,
    // renameTask: true,
};

/**
 * 同一路径对应多个 key 时的 mock 消歧表：按请求方法匹配对应 key。
 * 现所有任务接口路径已互不相同（/tasks、/tasks/list、/tasks/detail、/tasks/delete），
 * 无需再按方法消歧，保留空表以兼容 request.js 的引用。
 */
export const MOCK_URL_METHOD = {};

export default ALL_URL;
